'use client';

import { TableBase } from './TableBase';

import type {
  TableBaseImplProps,
  DistributiveOmit,
} from './TableBaseImpl.types';

type InfiniteTableProps<T> = DistributiveOmit<
  TableBaseImplProps<T>,
  | 'paginationMode'
  | 'page'
  | 'defaultPage'
  | 'pageSize'
  | 'defaultPageSize'
  | 'onPageChange'
  | 'onPageSizeChange'
> & {
  onLoadMore: () => void;
  hasMore?: boolean;
};

export function InfiniteTable<T extends Record<string, any>>(
  props: InfiniteTableProps<T>,
) {
  return <TableBase {...props} paginationMode="infinite" />;
}
